/*
 * Size selector — the size link, its drawer, and the Add to cart gate.
 *
 * Sizes are not reimplemented: picking a row checks the theme's own hidden
 * radio and fires a change event, so <variant-selects> updates the variant,
 * price and form exactly as if the swatch had been clicked.
 *
 * Add to cart is gated because Shopify pre-selects the first variant, so
 * without this a customer who never opened the drawer silently buys the
 * smallest size. While no size has been chosen the button is disabled, says
 * so, and opens the drawer when clicked - a disabled button that explains the
 * problem but offers no way out is worse than no gate at all.
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var drawer = document.querySelector('[data-size-drawer]');
  var trigger = document.querySelector('[data-size-selector-open]');
  if (!drawer || !trigger) return;

  var labelEl = document.querySelector('[data-size-selector-label]');
  var addBtn = document.querySelector('[data-add-to-cart]');
  var addText = addBtn ? addBtn.querySelector('[data-add-to-cart-text], .btn__text') : null;
  var addTextOriginal = addText ? addText.textContent.trim() : 'Add to cart';

  // The option name drives the radio lookup; read it off the first radio so a
  // renamed option (Ring size / Size) keeps working.
  var firstRadio = document.querySelector('.product__selectors input[type="radio"]');
  var radioName = firstRadio ? firstRadio.name : null;
  // Read from the attribute, not the button's own text: parsing the label back
  // out of the text it was rendered with is how it ended up doubling.
  var optionLabel = (trigger.getAttribute('data-size-option-name') || 'size').toLowerCase();

  var hasChosen = false;

  function sizeInputs() {
    if (!radioName) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('input[type="radio"][name="' + CSS.escape(radioName) + '"]')
    );
  }

  function selectedSize() {
    var checked = sizeInputs().filter(function (i) { return i.checked; })[0];
    return checked ? checked.value : null;
  }

  function refresh() {
    var v = selectedSize();

    if (labelEl) {
      labelEl.textContent = hasChosen && v
        ? optionLabel.charAt(0).toUpperCase() + optionLabel.slice(1) + ': ' + v
        : 'Select your ' + optionLabel;
    }
    trigger.classList.toggle('is-chosen', hasChosen);

    if (addBtn) {
      // Genuinely disabled, so the theme's own grey styling applies. This
      // matches the variant gate already used on Star Sign earrings and the
      // other multi-variant products, so the site behaves one way throughout.
      // The "Select your ring size" link sits directly above and carries the
      // explanation, which is why a dead button is not confusing here.
      addBtn.disabled = !hasChosen;
      if (addText) addText.textContent = addTextOriginal;
    }

    drawer.querySelectorAll('[data-size-value]').forEach(function (btn) {
      var on = hasChosen && btn.getAttribute('data-size-value') === v;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // The theme header is its own stacking context at z-index 2300 and was
    // painting over the top of the drawer. Demoting it while the drawer is
    // open settles it regardless of how the contexts nest.
    document.body.classList.add('size-drawer-open');
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('size-drawer-open');
  }

  trigger.addEventListener('click', open);

  drawer.querySelectorAll('[data-size-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  drawer.querySelectorAll('[data-size-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-size-value');
      var input = sizeInputs().filter(function (i) { return i.value === value; })[0];
      if (input) {
        input.checked = true;
        // Bubbles so <variant-selects> picks it up and updates price + form.
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      hasChosen = true;
      refresh();
      close();
    });
  });

  var requestOpen = drawer.querySelector('[data-size-request-open]');
  var requestBox = drawer.querySelector('[data-size-request]');
  var list = drawer.querySelector('[data-size-list]');
  var help = drawer.querySelector('[data-size-help]');

  function showSizes() {
    if (requestBox) requestBox.hidden = true;
    if (requestOpen) requestOpen.hidden = false;
    if (list) list.hidden = false;
    if (help) help.hidden = false;
  }

  function showRequest() {
    if (!requestBox) return;
    requestBox.hidden = false;
    if (requestOpen) requestOpen.hidden = true;
    if (list) list.hidden = true;
    if (help) help.hidden = true;
  }

  if (requestOpen) {
    requestOpen.addEventListener('click', function () {
      showRequest();
      var first = requestBox.querySelector('input');
      if (first) first.focus();
    });
  }

  // Without this the only way back to the size list was a page reload.
  var requestBack = drawer.querySelector('[data-size-request-back]');
  if (requestBack) requestBack.addEventListener('click', showSizes);

  // Closing the drawer resets it to the size list, so reopening never lands
  // on the request form unexpectedly.
  drawer.querySelectorAll('[data-size-drawer-close]').forEach(function (el) {
    el.addEventListener('click', showSizes);
  });

  // Build the mailto as they type, so the mail client opens with the product,
  // its URL and the size already in the body. See the snippet for why this is
  // not a web form.
  var sendLink = drawer.querySelector('[data-size-request-send]');
  if (sendLink && requestBox) {
    var field = function (n) {
      var el = requestBox.querySelector('[data-size-field="' + n + '"]');
      return el ? el.value.trim() : '';
    };
    var buildMailto = function () {
      var title = (document.querySelector('.product__title, h1') || {}).textContent || document.title;
      title = title.trim();
      var body = 'Hello,\n\nI would like to request this piece in a different size.\n\n'
        + 'Piece: ' + title + '\n'
        + 'Page: ' + window.location.href.split('?')[0] + '\n'
        + 'Size needed: ' + (field('size') || '(please fill in)') + '\n\n'
        + (field('note') ? field('note') + '\n\n' : '')
        + 'Thank you.';
      sendLink.setAttribute('href',
        'mailto:atelier@hriamjewels.com'
        + '?subject=' + encodeURIComponent('Size request: ' + title)
        + '&body=' + encodeURIComponent(body));
    };
    requestBox.addEventListener('input', buildMailto);
    buildMailto();
  }

  refresh();
})();
